module.exports = __webpack_public_path__ + "static/Logistik-9335b6a6a5aae304fac6a953c73e3708.gif";